import { render, staticRenderFns } from "./OpcionDialogAddGeneral.vue?vue&type=template&id=798f91ff&scoped=true"
import script from "./OpcionDialogAddGeneral.vue?vue&type=script&lang=js"
export * from "./OpcionDialogAddGeneral.vue?vue&type=script&lang=js"
import style0 from "./OpcionDialogAddGeneral.vue?vue&type=style&index=0&id=798f91ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798f91ff",
  null
  
)

export default component.exports